import React from 'react';
import {connect} from 'react-redux';
import styled from 'styled-components';
import {Modal} from "react-bootstrap";
import {selectCheckedItemsContentIDs, selectIsSaveEnabled, selectSharedFSRoot} from '../../../selectors';
import {FS_ACTION_TYPE__LKFS_ANALYSIS_PORTAL} from '../../../constants';
import {sendLKFSRequest, setFrameRate, STORAGE_MNG_LKFS_SWITCH_MODAL,} from "../../../actions";
import ReportBugButton from "../../../../../components/ReportBugButton";
import {showError} from "../../../../../layouts/actions";
import store from "../../../../../store";
import {InitialScreenConnected} from "./FirstStep";
import RndModal from "../../../../../components/modals/RndModal";
import AudioChannelsStep from "./AudioChannelsStep";
import { confirmAlert } from 'react-confirm-alert';

const onCloseModal = () => ({ type: STORAGE_MNG_LKFS_SWITCH_MODAL, isShow: false });

const STEP_INITIAL = 1;
const STEP_AUDIO_CHANNELS = 2;

/*#region LKFSModal */
export const StyledLkfsModal = styled(RndModal)`
  .error-message {
    color: #f00;
  }
  .container-fluid {
    min-height: unset !important
  }
  .add-to-wo--first-step {
    .container-fluid {
      min-height: 130px !important;
    }
    .react-draggable {
      min-height: 300px !important;
    }
  }
  .lkfs-modal-large {
    /*width:90%;*/
    .modal-content {
      min-height: 50vh;
      max-height: 80vh;
      .react-draggable {
        min-height: 50vh !important;
        max-height: 80vh !important;
      }
    }
    .modal-body {
      padding: 0;
      overflow: hidden;
      > div, > .container-fluid > div {
        height: 100%;
        > div {
          height: 100%;
          .container {
            height: calc(100% - 64px);
            .requests-content {
              height: 100%;
              > div {
                height: 100%;
              }
            }
          }
        }
      }
    }
    .custom-scrollbar {
      &::-webkit-scrollbar-track {
        -webkit-box-shadow: none;
        background-color: transparent;
      }
      &::-webkit-scrollbar {
        width: 8px;
        height: 8px;
        background-color: transparent;
      }
      &::-webkit-scrollbar-thumb {
        border-radius: 100px;
        -webkit-box-shadow: none;
        background-color: #c4c4c4;
      }
      @media (max-width: 991px) {
        height: auto;
        border-top: 0.5px solid #efefef;
      }
    }
  }

`;

class LKFSModal extends React.Component {
  state = {
    selectedFolder: null,
    currentStep: STEP_INITIAL,
  };

  allowNewFeature = () => {
    const {email} = store.getState().user;
    return email && true; //(email.includes('berkman') || email.includes('morozov'));
  }

  handleCloseModal = () => {
    const {onCloseModal} = this.props;
    confirmAlert({
      childrenElement: () =>
        <h5 className="custom-msg">
          Are you sure you want to cancel "LKFS" wizard?
        </h5>,
      buttons: [{
        label: 'No'
      }, {
        label: 'Yes',
        onClick: () => {
          onCloseModal();
        }
      }]
    });
  };

  onContinue = () => {
    const {currentStep} = this.state;
    if (this.allowNewFeature()) {
      if (currentStep === STEP_INITIAL) {
        // we click Continue on first step -> go to second step
        this.setState({currentStep: STEP_AUDIO_CHANNELS});
      } else {
        // we click Continue on second step -> submit data
        this.props.onSubmit(this.props.submitData, this.props.frameRateValue, this.props.channelSetsData);
      }
      return;
    }

    // we click Continue on first step -> submit data
    this.props.onSubmit(this.props.submitData, this.props.frameRateValue);
  }

  onBack = () => {
    this.setState({currentStep: STEP_INITIAL});
  }

  renderFirstStep = () => {
    return (
      <InitialScreenConnected
        onCancel={this.handleCloseModal}
        onContinue={this.onContinue}
      />
    );
  }

  renderSecondStep = () => {
    return (
      <AudioChannelsStep
        onCancel={this.handleCloseModal}
        onBack={this.onBack}
        onContinue={this.onContinue}
      />
    );
  }

  render() {
    const {
      isSelectingWOMemfis,
    } = this.props;

    return (
      <StyledLkfsModal
        className={'wizard--modal'}
        dialogClassName={isSelectingWOMemfis ? 'lkfs-modal-large' : 'lkfs-modal'}
        bsSize="large"
        width={isSelectingWOMemfis ? '90%' : undefined}
        backdrop="static"
        enforceFocus={false}
        show={true}
        onHide={this.handleCloseModal}
      >
        <Modal.Header>
          <Modal.Title>
            LKFS
            <ReportBugButton isForModal={true} />
          </Modal.Title>
        </Modal.Header>
        {this.state.currentStep === STEP_INITIAL ? this.renderFirstStep() : this.renderSecondStep()}
      </StyledLkfsModal>
    );
  }
}

function mapStateToProps(state) {
  const {
    AMBCurrent,
    currentDestination,
    currentWOMemfis,
    initialWOMemfis,
    isSelectingWOMemfis,
    isSelectingDestination,
    frameRate,
    dbFrameRate,
    newFrameRate,
    errorType,
    isEnable,
    audioChannelSetsData
  } = state.storageManager.LKFSModalState;
  return {
    checkedItems: state.storageManager.checkedItems,
    isSelectingWOMemfis,
    isSelectingDestination,
    isSaveEnabled: selectIsSaveEnabled(state),
    initialWOMemfis,
    channelSetsData: audioChannelSetsData,
    frameRateValue: {
      'frameRate': frameRate,
      'dbFrameRate': dbFrameRate,
      'newFrameRate': newFrameRate,
      'errorType': errorType,
      'woMemfis': currentWOMemfis,
      'isEnable': isEnable
    },
    submitData: {
      "actionType": FS_ACTION_TYPE__LKFS_ANALYSIS_PORTAL,
      "fsRootID": selectSharedFSRoot(state),
      "fsRootID2": currentDestination.fsRootID,
      "parameters": {
        "ContentIDs": selectCheckedItemsContentIDs(state),
        "WO_MEMFIS": currentWOMemfis,
        "DESTINATION": currentDestination.key,
        "AMB_SETTINGS": AMBCurrent,
      }
    },
  };
}

function mapDispatchToProps(dispatch) {
  return {
    onCloseModal: () => dispatch(onCloseModal()),
    onSubmit: (data, frameRateValue, channelSetsData) => {
      if (frameRateValue && frameRateValue.isEnable) {
        const newFrameRate = frameRateValue.newFrameRate;
        const frameRate = frameRateValue.frameRate;
        const woMemfis = frameRateValue.woMemfis;
        const errorType = frameRateValue.errorType;
        if (errorType !== null && errorType !== "success") {
          if (newFrameRate !== null) {
            dispatch(setFrameRate(newFrameRate, true, woMemfis));
          } else if (frameRate !== null) {
            dispatch(setFrameRate(frameRate, false, woMemfis));
          } else {
            dispatch(showError(`Frame Rate not set`));
            return;
          }
        } else if (errorType === "success") {
          if (newFrameRate !== null && frameRate !== null && newFrameRate !== frameRate) {
            dispatch(setFrameRate(newFrameRate, true, woMemfis));
          } else if (newFrameRate === null && frameRate !== null) {
            dispatch(setFrameRate(frameRate, false, woMemfis));
          } else {
            dispatch(showError(`Frame Rate not set`));
            return;
          }
        }
      }

      if (channelSetsData && channelSetsData.length > 0) {
        const actionJsonParams = channelSetsData.map(item => ({
          content_id: item.file.contentID,
          skip: item.data && item.data.skip,
          channel_sets: item.data && item.data.channelSets && item.data.channelSets.length > 0 ?
            `[${item.data.channelSets.map(set => set.channels).join(',')}]` :
            '',
          disabled_sets: item.data && item.data.channelSets ?
            item.data.channelSets.map((set, index) => set.enabled === false ? index : null)
              .filter(index => index !== null)
              .join(',') :
            ''
        }));
        data.parameters.LKFS_AUDIO_CHANNEL_SETS = JSON.stringify(actionJsonParams);
      }

      dispatch(onCloseModal());
      dispatch(sendLKFSRequest(data));
    },
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(LKFSModal);
